// eslint-disable-next-line no-shadow
enum MessageBoxType {
    INFO,
    ERROR,
    WARNING,
    SUCCESS,
}

export default MessageBoxType;
